<ion-text class="status-preenchimento">
  <ion-icon [name]="iconeStatus" [color]="iconeStatusCor"></ion-icon>
  {{ statusPreenchimento | statusPreenchimento }}
</ion-text>
